class SiteKeyboard
{
    private readonly _site: Site;

    constructor (site: Site)
    {
        this._site = site;
        
        QueryElement.get(document.body).on("keydown", (e: KeyboardEvent) => {
            if(this.keyDown(e.keyCode)) {
                e.stop();
            }
        });
    }
    keyDown(keyCode: number): boolean {
        switch(keyCode) {
            case 113: // F2
                this._site.showHideConfidential();
                return true;
        }
        
        return false;
    }
}